import 'rsuite/DateRangePicker/styles/index.css';

import { displayErrorDetails } from '@brands/Utils/displayError';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import React, { FC, useState } from 'react';
import { DateRangePicker } from 'rsuite';

import styles from './MinimalDateRangePicker.module.scss';

interface HandleDateRangeFilterChangeProps {
  handleDateRangeFilterChange: (key: string, value: [Date, Date] | null) => void;
  filterKey: string;
  selectedRange: [Date, Date] | null;
  width?: string | number;
  openToLeft?: boolean;
  /** Empty-state label on the toggle (default matches legacy grids). */
  placeholder?: string;
}

const MinimalDateRangePicker: FC<HandleDateRangeFilterChangeProps> = ({
  handleDateRangeFilterChange,
  filterKey,
  selectedRange,
  width = 280,
  openToLeft = false,
  placeholder = 'Select date range',
}) => {
  const [dateRange, setDateRange] = useState<[Date, Date] | null>(selectedRange);

  const handleOk = (selectedRange: [Date, Date] | null) => {
    if (selectedRange) {
      const [startDate, endDate] = selectedRange;
      if (startDate && endDate && startDate <= endDate) {
        handleDateRangeFilterChange(filterKey, selectedRange);
      } else {
        displayErrorDetails('Invalid date range: Start date must be before or equal to end date.');
      }
    } else {
      handleDateRangeFilterChange(filterKey, null);
    }
  };

  const handleDateRangeChange = (range: [Date, Date] | null) => {
    setDateRange(range);

    if (!range) {
      handleDateRangeFilterChange(filterKey, null);
    } else {
      const [startDate, endDate] = range;
      if (startDate && endDate && startDate <= endDate) {
        handleDateRangeFilterChange(filterKey, range);
      }
    }
  };

  return (
    <div className={styles.dateRangePickerDiv}>
      <DateRangePicker
        value={dateRange}
        onChange={handleDateRangeChange}
        onOk={handleOk}
        format="MM/dd/yyyy"
        style={{ paddingLeft: 0, width }}
        ranges={[]}
        placeholder={placeholder}
        cleanable
        placement={openToLeft ? 'bottomEnd' : 'bottomStart'}
        caretAs={CalendarTodayIcon}
      />
    </div>
  );
};

export default MinimalDateRangePicker;
